import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// A custom theme for this app
export const getTheme = (direction = "rtl") =>
  createTheme({
    direction,
    spacing: (factor) => {
      if (typeof factor !== "number") return factor;
      return `clamp(${factor * 4}px, ${factor * 0.5}vw, ${factor * 8}px)`;
    },
    typography: {
      fontFamily: ["Cairo"].join(","),
      h2: {
        fontSize: "24px",
        "@media (max-width: 600px)": {
          fontSize: "18px",
        },
      },
    },
    palette: {
      primary: {
        // main: "#556cd6",
        main: "#6C4192",
      },
      secondary: {
        main: "#F25500",
        // main: "#d9b4f9",
      },
      error: {
        main: red.A400,
      },
    },
    theme_palette: {
      primary: "#6C4192",
      // orange: "#F25500",
      orange: "#6d4096",
      red: "#D92C32",
      // oliveGreen: "#3FABAE",
      oliveGreen: "#c77dff",
      green: "#29B95F",
      gray: "#939393",
      grayOne: "#A3A3A3",
      grayBorder: "#E7E7E7",
      textGray: "#1A1A1A",
      lightGray: "#ddd",
      backgroundGray: "#F2F2F2",
      labelColor: "#9F9F9F",
      borderColor: "#F2F2F2",
      offWhite: "#FAFAFA",
      grayTwo: "#7D7D7D",
      grayThree: "#F0F0F0",
      grayfour: "#7E7E7E",
      grayFive: "#E2E2E2",
      graySex: "#EEE",
      blackTwo: "#545454",
      graySeven: "#4A4A48",
      redTwo: "#F55500",
      gray9: "#5A5A5A",
      gray10: "#585858",
      orangeTwo: "#D20000",
      lightGreen: "#09CE7D",
      lightGreenTwo: "#E1F5E8",
      borderColorTwo: "#F4F4F4",
      backgroundGreen: "#E1F5E8",
      textGreen: "#29B95F",
      backgroundRed: "#FAE3E3",
      textRed: "#D20000",
      yellow: "#FFCC00",
      backgroundYellow: "#FCFFE9",
      confirmationGreen: "#29B95F",
      inputBg: "#FBFBFB",
      graySix: "#E3E3E3",
      gray17: "#F3F3F3",
      gray11: "#A3A3A3",
      darkBlue: "#09132C",
      chatListBg: "#F3FAFA",
      darkGray: "#191919",
    },
    overrides: {
      MuiPaper: {
        root: {},
      },
    },
    components: {
      MuiDialog: {
        styleOverrides: {
          paper: {
            width: "50%",
            maxWidth: "1072px",
            margin: "32px",
            "@media (max-width: 900px)": {
              width: "70%",
              maxWidth: "800px",
            },
            "@media (max-width: 600px)": {
              width: "90%",
              maxWidth: "95%",
              minWidth: "auto",
              margin: "16px",
            },
          },
        },
      },
      MuiButton: {
        defaultProps: {
          disableRipple: true, // No more ripple, on the whole application !
          disableElevation: true,
        },
        styleOverrides: {
          root: {
            // Some CSS
            borderRadius: "4px",
            "&:hover": {
              //  backgroundColor: 'primary',
            },
            gap: "8px",
            padding: "8px 97px",
            // width:"250px",
            fontFamily: "Cairo",
            textTransform: "none",
            fontSize: "18px",
            fontWeight: "400",
            "@media (max-width: 600px)": {
              padding: "8px 24px",
              fontSize: "16px",
            },
          },
          startIcon: {
            marginLeft: 0,
            marginRight: 0,
          },
          endIcon: {
            marginLeft: 0,
            marginRight: 0,
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            border: "none",
            padding: "15px",
            fontSize: "16px",
            whiteSpace: "nowrap",
            "@media (max-width: 900px)": {
              fontSize: "14px",
            },
            "@media (max-width: 600px)": {
              padding: "12px 8px",
              fontSize: "12px",
            },
          },
        },
      },
      MuiStack: {
        defaultProps: {
          useFlexGap: true,
        },
      },
    },
  });
